class Resources {

}
const TYPES = {
  template: 8,
  scene: 12,
  background: 3,
  text: 16,
  character: 14,
  material: 17,
  shape: 15,
  prop: 17,
  gif: 37,
  sound: 5,
  combo: 16,
  gesture: 7
}
export const PayTypes = {
  free: '0',
  pay: '1,2,3',
  // member: '4,6',
  person: '4',
  company: '6'
}

export function filterResponse(resp) {
  return resp.status == 200 ? resp.data : null;
}
function deleteUndef(obj) {
  Object.keys(obj).forEach(key => {
    let val = obj[key];
    if (val == null) {
      delete obj[key];
    }
  })
}
export class Search {
  constructor({ http, onResourcesFetched = () => {} } = {}) {
    this.http = http;
    this.onResourcesFetched = onResourcesFetched;
    this.params = {
      type: 8,
      pIndex: 1,
      sOfPage: 24,
      fPage: 24,
      // style: 78,
      // payType: 0, // 不传即全部
      // isCommerical: 1, // 不传即全部，1：可商用；0：不可商用
      // direction: 1,
      // keyword
      // draftId: draftId || 'c0536fcb-0d8c-43eb-aa26-a2ce974df299'
    }
    this.paging = {
      pIndex: 1,
      sOfPage: 24,
      fPage: 24,
    }
    this.userApis = {
      image: '/api/user/pic',
      sound: '/api/user/music',
      video: '/api/user/video',
      multiImage: '/api/user/pic/multiples'
    }
  }

  async get({ url = '/api/common/material', params = {}, options = {} } = {}) {
    if (options.type === 'likes') {
      return this.getLikes({ params, });
    }
    let { type = 'material', payType } = params;
    const inputParams = params;
    params = {
      ...this.params,
      // draftId: location.hash.slice(2),
      ...params,
      type: TYPES[type] || type,
    }

    if (type === 'template') {
      url = '/api/home/template';
      delete params.type;
    }
    if (type === 'character' && params.keyword) {
      url = '/api/common/material/findCharacterActionByName';
      delete params.type;
    }
    if (payType && PayTypes[payType]) {
      params.payType = PayTypes[payType];
      if (type === 'template' && payType === 'person') {
        params.payType = '1,4';
      }
    }
    let resp = await this.http.get(url, { params });
    this.onResourcesFetched({
      params: inputParams,
      require: params,
      response: resp
    });
    return filterResponse(resp);
  }

  async searchAll({ keyword = '' } = {}) {
    let resp = await this.http.get('/api/common/material/findAll', {
      params: { keyword }
    });

    let respData = filterResponse(resp);
    if (!respData) {
      return null;
    }
    let totalDict = respData.data || {};
    let { gifTotal, picTotal, propTotal, shapeTotal } = totalDict;
    totalDict.materialTotal = gifTotal + picTotal + propTotal + shapeTotal;
    totalDict.total = Object.keys(totalDict).reduce((memo, key) => {
      return memo + totalDict[key]
    }, 0);
    totalDict.scene = totalDict.sceneTotal;
    totalDict.template = totalDict.templateTotal;
    totalDict.background = totalDict.bgTotal;
    totalDict.text = totalDict.textTotal;
    totalDict.character = totalDict.characterTotal;
    totalDict.material = totalDict.materialTotal;
    totalDict.sound = totalDict.musicTotal;

    return respData;
  }

  async getLikes({ url = '', params = {} } = {}) {
    let { type = '' } = params;
    let typeString = type;
    let apis = {
      template: '/api/user/template',
      scene: '/api/user/scene',
      likes: '/api/user/favorites/type',
      material: '/api/user/favorites'
    }
    url = apis[type] || apis.likes;
    params = {
      ...this.paging,
      ...params
    };
    if (type === 'template') {
      params.type = 3;
    } else if (typeString === 'material') {
      params.type = void 0;
      params.getDefault = 1;
      params.getDefalt = 1;
    }
    else {
      params.type = TYPES[type] || params.type;
    }
    if (typeString === 'scene' && params.keyword) {
      url = '/api/user/favorites/type';
    }
    const resp = await this.http.get(url, { params });
    return filterResponse(resp);
  }

  async getUploaded({ url = '', params = {}, options = {} } = {}) {
    if (options.type === 'team') {
      return this.getTeamItems({ params });
    }
    let { type = '' } = params;
    let apis = this.userApis;
    url = apis[type] || url;
    params = { ...this.paging, ...params, type: void 0 };
    if (type === 'video') {
      params.type = 1;
      params.fileType = 26;
    }
    const resp = await this.http.get(url, { params });
    return filterResponse(resp);
  }

  // 素材分类: 	1视频，3：背景，4、图片和gif，5：音乐和录音 8：模板 50:项目
  // async getTeamItems ({ params = {} } = {}) {
  // return this.getTeamItems({params});
  // let map = {
  //   video: 1,
  //   background: 3,
  //   image: 4,
  //   sound: 5,
  //   template: 8,
  //   draft: 55,
  //   logo: 54
  // }
  // let type = map[params.type] || type;
  // let typeStr = params.type;
  // params = {
  //   ...this.paging, ...params, type, share: 1
  // }
  // let url = '/api/user/account/family/material';
  // if (typeStr === 'video') {
  //   params.type = 1;
  //   params.fileType = 26;
  // }
  // if (typeStr === 'logo') {
  //   url = '/api/user/brand/logo';
  //   params.type = void 0;
  // }
  // if (typeStr === 'template') {
  //   url = '/api/user/account/template'
  //   params.type = 'temp';
  //   params.share = 1;
  //   // params.direction = 1;
  // }
  // if (typeStr === 'draft') {
  //   url = '/api/user/account/cooperation/templateR'
  // }
  // const resp = await this.http.get(url, { params });
  // return filterResponse(resp);
  // }

  async getUserCate({ params = {}, options = {} } = {}) {
    let { type = '' } = params;
    let defs = {
      share: 0,
      ourself: 1
    };

    let url = '/api/user/material/category';
    let typeMap = {
      video: 1,
      background: 3,
      image: 4,
      sound: 5,
      template: 8,
      draft: 50
    }
    params = {
      ...defs,
      ...params,
      type: typeMap[type] || type
    };
    if (type === 'video') {
      params.fileType = 26;
    }
    if (options.type === 'team') {
      delete params.ourself;
      delete params.share;
      params.isNew = true;
    }
    const resp = await this.http.get(url, { params });
    return filterResponse(resp);
  }

  async removeUserItem({ id = '', type = '' } = {}) {
    let apis = this.userApis;
    let url = apis[type];
    if (Array.isArray(id)) {
      id = id.join(',')
    }
    const resp = await this.http.delete(url + '/' + id);
    return filterResponse(resp);
  }

  async moveUserItem() {

  }

  async searchUserItem({ keyword, options = {} } = {}) {
    if (options.type === 'team') {
      return this.searchTeamItem({ keyword });
    }
    // console.log("options", options);
    const resp = await this.http.get('/api/user/material/findAll', {
      params: {
        keyword
      }
    });
    const { pic: image, video, music: sound } = (resp.data || {}).data || {};
    resp.data = {
      image,
      video,
      sound
    };
    return filterResponse(resp);
  }

  async searchTeamItem({ keyword } = {}) {
    const resp = await this.http.get('/api/user/account/cooperation/countAllMaterialTool', {
      params: {
        keyword
      }
    });
    const { pic: image, video, music: sound, template, sharedraft: draft, brandlogo: logo } = (resp.data || {}).data || {};
    resp.data = {
      image,
      video,
      sound,
      template,
      draft,
      logo
    };
    return filterResponse(resp);
  }

  // 1：视频，4、图片，5：音乐，8：模板 54：团队logo，55：团队模板
  async getTeamItems({ keyword, type, params = {} } = {}) {
    let map = {
      video: 1,
      image: 4,
      sound: 5,
      template: 8,
      draft: 55,
      logo: 54
    }
    type = map[type] || map[params.type || ''] || type || params.type;
    params.type = type;
    const resp = await this.http.get('/api/user/account/cooperation/getMaterialTool', {
      params: {
        ...this.paging,
        keyword,
        type,
        ...params
      }
    });
    if (resp.status === 200) {
      resp.data.data = resp.data.data.map(v => {
        if (v.logoUrl) {
          return {
            ...v,
            url: v.logoUrl
          }
        }
        return v;
      });
    }
    return filterResponse(resp);
  }

  async addUploadedItem({ type, thumbnailUrl = '', title = '', url = '', ...rest } = {}) {
    let apis = {
      ...this.userApis,
      video: '/api/user/video/uploadVideo',
      multiImage: '/api/user/pic/multiples'
    };
    let api = apis[type] || '';
    const resp = await this.http.post(api, {
      url,
      title,
      thumbnailUrl,
      ...rest
    });
    return filterResponse(resp);
  }

  async setUploadedItem({ id = '', type = '', title = '', options = {} } = {}) {
    if (options.type === 'team') {
      return this.setTeamItem({ id, type, title });
    }
    let apis = this.userApis;
    let url = apis[type] || '';
    const resp = await this.http.put(url + '/' + id, { title });
    return filterResponse(resp);
  }

  async setTeamItem({ id = '', type = '', title = '' } = {}) {
    let map = {
      video: 1,
      image: 4,
      sound: 5,
      template: 8,
      draft: 55,
      logo: 54
    };
    type = map[type] || type;
    await this.http.post('/api/user/account/material/updateMaterialName', {
      id, type, title
    });
  }

  async getRecent({ type = '', direction = '' } = {}) {
    let typeString = type;
    let getDefault;
    type = TYPES[type] || type;
    let url = type == null ? '/api/user/materialUseInfo' : '/api/user/materialUseInfo/type';
    if (typeString === 'material') {
      url = '/api/user/materialUseInfo';
      getDefault = 1;
    }
    let resp = await this.http.get(url, {
      params: { type, direction, getDefault }
    });
    return filterResponse(resp);
  }

  async setRecent({ type, id, direction } = {}) {
    type = TYPES[type] || type;
    let resp = await this.http.post('/api/user/materialUseInfo', {
      type,
      id,
      direction
    });
    return filterResponse(resp);
  }

  async getHotWords({ type = 3 } = {}) {
    let params = {};
    params.type = TYPES[type] || type;
    let resp = await this.http.get('/api/common/material/recommendTag', {
      params
    });
    return filterResponse(resp);
  }
}

export class Category {
  constructor({ http = {} } = {}) {
    this.http = http;
    this.parmas = {
      // style: 78,
      type: 8
    }
  }

  async get({ params = {} } = {}) {
    let { type } = params;
    params = {
      ...this.params,
      ...params,
      type: TYPES[type] || type
    };
    const resp = await this.http.get('/api/home/category', {
      params
    });
    return filterResponse(resp);
  }
}

export class Resource {
  constructor({ http = {} } = {}) {
    this.http = http;
    this.params = {
      type: 3
    }
  }

  async likes({ id = '', flag = true, type = 3, ...rest } = {}) {
    let typeStr = type;
    type = TYPES[type] || type || this.params.type;
    let url = '/api/user/favorites';
    if (typeStr === 'template') {
      url = flag ? '/api/user/template/favorites' : '/api/user/template/cancelFavorites';
      const resp = await this.http.post(url, { id });
      return filterResponse(resp);
    }
    if (typeStr === 'draftScene' && flag) {
      url = '/api/user/scene';
      const resp = await this.http.post(url, {
        ...rest
      });
      return filterResponse(resp);
    }
    if (typeStr === 'draftScene' && !flag) {
      url = '/api/user/scene';
      const resp = await this.http.delete(url + '/' + id);
      return filterResponse(resp);
    }
    let params = {
      type,
      id,
    }
    if (!flag) {
      params.isCancel = 1
    }
    const resp = await this.http.post(url, params);
    return filterResponse(resp);
  }
}

export class Upload {
  constructor({ http = {} } = {}) {
    this.http = http;
  }
  async image({ formDatas } = {}) {
    let url = '/api/upload/file';
    let res = await this.http.post(url, formDatas, {
      dataType: "json",
      processData: false,
      contentType: false
    })
    return filterResponse(res);
  }
  async scene(params) {
    let url = '/api/user/scene';
    let res = await this.http.post(url, params);
    return filterResponse(res);
  }
}



// WEBPACK FOOTER //
// ./src/http/resources.js